import { ServiceRequestConfiguration } from "./ServiceRequestConfigurationInterface";

const devTenantServiceRequestConfiguration: ServiceRequestConfiguration = {
    debug: true,
    baseUrl: "http://localhost:8000/",
    restServicesPath: "api/",
    appClientId: "b6773abd-23e9-4d1d-9b99-0924f844fd16",
    appAuthority: "https://login.microsoftonline.com/76149153-43d3-43a9-adde-68c1de659755",
    redirectUri: "http://localhost:8000/callback",
    cacheLocation: "localStorage",
    loginRequestScopes: ["api://e76dee79-997d-4428-94e3-cb0802a161ec/access"],
    tokenRequestScopes: ["User.ReadWrite"],
    graphUsersEndpoint: "https://graph.microsoft.com/v1.0/users",
};

const luxTenantServiceRequestConfiguration: ServiceRequestConfiguration = {
    debug: false,
    baseUrl: "/",
    restServicesPath: "api/",
    appClientId: "e14d68df-f824-4709-9acb-4cd9a3c81c7e",
    appAuthority: "https://login.microsoftonline.com/c7d1a8f7-0546-4a0c-8cf5-3ddaebf97d51",
    redirectUri: "/",
    cacheLocation: "localStorage",
    loginRequestScopes: [
        "api://3c56a349-9ecd-4bbe-a149-092028f4cc5a/Access",
    ],
    tokenRequestScopes: ["User.Read"],
    graphUsersEndpoint: "https://graph.microsoft.com/v1.0/users",
};

export { devTenantServiceRequestConfiguration, luxTenantServiceRequestConfiguration };